// src/pages/SwachhBharat.js
import React from "react";

export default function SwachhBharat() {
  const styles = {
    container: {
      padding: "20px",
      maxWidth: "900px",
      margin: "0 auto",
      fontFamily: "Arial, sans-serif",
      lineHeight: "1.6",
      color: "#333",
    },
    heading: {
      textAlign: "center",
      marginBottom: "20px",
      color: "#2c3e50",
    },
    section: {
      marginBottom: "20px",
    },
    list: {
      paddingLeft: "20px",
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>पाणी व स्वच्छता विभाग</h1>

      <div style={styles.section}>
        <h2>विभागाची प्रस्तावना</h2>
        <p>
          मा. मुख्य कार्यकारी अधिकारी, जि.प. भंडारा यांचे मार्गदर्शनात आणि 
          मा. प्रकल्प संचालक तसेच उप मुख्य कार्यकारी अधिकारी (पाणी व स्वच्छता), 
          जि.प. भंडारा व मा. गट विकास अधिकारी, पंचायत समिती तुमसर यांच्या नेतृत्वात 
          ग्रामस्तरावर पाणी व स्वच्छता कार्यक्रमाची अंमलबजावणी करण्यात येते.
        </p>
        <p>
          पाणी व स्वच्छता विभागाचा उद्देश ग्रामीण भागांतील नागरिकांना सुरक्षित, स्वच्छ व पुरेसा पिण्याचा पाणीपुरवठा करणे आणि 
          स्वच्छतेची प्रभावी सुविधा उपलब्ध करून देणे हा आहे. या विभागामार्फत जल जीवन मिशन व स्वच्छ भारत मिशन कार्यक्रमाची 
          अंमलबजावणी करून वैयक्तिक ते सार्वजनिकस्तरीय सुविधा निर्माण केली जातात.
        </p>
      </div>

      <div style={styles.section}>
        <h2>महत्त्वाचे कार्य</h2>
        <ul style={styles.list}>
          <li>स्वच्छ भारत मिशन (ग्रा.) टप्पा 2 व जल जीवन मिशन कार्यक्रमाची अंमलबजावणी करणे</li>
          <li>पाणी गुणवत्ता व सनियंत्रण कार्यक्रमाची अंमलबजावणी करणे</li>
          <li>नागरिकांना वैयक्तिक व सार्वजनिक स्तरावर स्वच्छता सुविधा पुरवणे</li>
          <li>वैयक्तिक व सार्वजनिक शौचालयांचे बांधकाम करणे</li>
          <li>घनकचरा व सांडपाणी व्यवस्थापनाची अंमलबजावणी करणे</li>
          <li>पाण्याचा शाश्वत वापर सुनिश्चित करणे</li>
          <li>ग्रामस्तरावर पाणी पुरवठा व स्वच्छता समितींचा सहभाग वाढविणे</li>
          <li>पाणी व स्वच्छता योजनांचे नियोजन, अंमलबजावणी आणि देखरेख करणे</li>
          <li>पाणी व स्वच्छता वापराबाबत जनजागृती करणे</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2>विभागाच्या योजनांची थोडक्यात माहिती</h2>
        <h3>स्वच्छ भारत मिशन टप्पा 2:</h3>
        <ul style={styles.list}>
          <li>वैयक्तिक शौचालयाचा लाभ देणे</li>
          <li>सार्वजनिक शौचालयाची सुविधा निर्माण करणे</li>
          <li>घनकचरा व्यवस्थापनाची अंमलबजावणी करणे</li>
          <li>सांडपाणी व्यवस्थापनाची अंमलबजावणी करणे</li>
          <li>प्लॉस्टीक कचरा व्यवस्थापन करणे</li>
          <li>मैलागाळ व्यवस्थापन करणे</li>
        </ul>

        <h3>जल जीवन मिशन (JJM):</h3>
        <ul style={styles.list}>
          <li>ग्रामीण भागातील कुटुंबांना नळाद्वारे स्वच्छ शुद्ध गुणवत्तापूर्ण पाणी पुरवठा करणे</li>
          <li>पिण्याच्या पाण्याच्या स्त्रोतांची रासायनिक व जैविक तपासणी करणे</li>
          <li>गाव हर घर जल घोषित करण्याची प्रक्रिया राबविणे</li>
          <li>पावसाचे पाणी साठवणे व भूजल पुनर्भरण करणे</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2>उद्देश</h2>
        <p>
          लोकसहभागातून दृश्यमान व शाश्वत स्वच्छता तसेच पाणी गुणवत्तेवर भर देणे 
          आणि ग्रामीण भागातील नागरिकांना सुरक्षित व स्वच्छ पाणीपुरवठा उपलब्ध करून देणे.
        </p>
      </div>
    </div>
  );
}
